<template>
  <div class="deliveryType">
    <div class="deliCont">
      <div class="top238">
        <div class="item">
          <div class="Fbtn" @click="toSelectBox">{{Language.Fresh.delivery_direct[isLanguage]}}</div>
          <div class="tips">{{Language.Fresh.tips_delivery_direct[isLanguage]}}</div>
        </div>
        <div class="item">
          <div class="Fbtn" @click="toScanCode">{{Language.Fresh.delivery_reserve[isLanguage]}}</div>
          <div class="tips">{{Language.Fresh.tips_delivery_reserve[isLanguage]}}</div>
        </div>
      </div>
      <div class="manageBtn" @click="toWarehous">{{Language.Fresh.manage_box[isLanguage]}}</div>
    </div>
    
    <!--超时组件-->
		<overTime :callBack="backUp"></overTime>
		<!--按钮组-->
		<EConfigBtn :pushBg="'#151c36'" :backUp="backUp" :quit="quit"></EConfigBtn>

    <!--未关箱格展示弹窗-->
    <el-dialog title="箱门状态" :visible.sync="notShutDio" width="50%" class="notShutDio">
      <div class="tips">注：红色表示箱门未关闭</div>
      <div class="contDio">
        <div class="item">1</div>
        <div class="item error">2</div>
        <div class="item">3</div>
        <div class="item">4</div>
        <div class="item">5</div>
        <div class="item">6</div>
        <div class="item">7</div>
        <div class="item">8</div>
        <div class="item">9</div>
        <div class="item error">10</div>
        <div class="item">11</div>
      </div>
      <span slot="footer">
        <div class="subBtn" @click="notShutDio = false">确定</div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import overTime from '../assets/overTime.vue'
import EConfigBtn from '../assets/ConfigBtn.vue'
import { conLog,storage } from '../../../../static/js/utils/utility'
var vm
export default {
  data(){
    return {
      configStorage:null,
				
      isLanguage:0,
      Language:'',

      notShutDio:true,//未关箱格弹窗
    }
  },
  components:{
    overTime,
    EConfigBtn,
  },
  async created(){
    vm = this
    var isLanguage = storage.localGetItem('isLanguage');
    if(isLanguage){
      this.isLanguage = isLanguage
    }
    this.Language = this.$Language
      
    this.$store.state.overTime = 80
    
  },
  mounted(){

  },
  methods:{
    //跳转到管理箱格
    toWarehous(){
      vm.$router.push({
        path:'/FreshCabinet/FWarehousList',
      })
    },
    //跳转到选择箱格
    toSelectBox(){
      vm.$router.push({
        path:'/FreshCabinet/FSelectBox'
      })
    },
    //跳转到扫码
    toScanCode(){
      vm.$router.push({
        path:'/FreshCabinet/FScanCode',
        query:{
          'type': 2
        }
      })
    },
    //返回上一页
    backUp(){
      storage.localRemoveItem('courierToken')
      storage.localRemoveItem('userInfo')
      vm.$router.push({
        path:'/FreshCabinet/FLogin'
      })
    },
    //退出登录
    quit(){
      storage.localRemoveItem('courierToken')
      storage.localRemoveItem('userInfo')
      vm.$router.push({
        path:'/FreshCabinet'
      })
    }
  },
  watch:{

  }
  
}
</script>

<style lang="less">
.deliveryType{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
	background: #f2f2f2;
  .notShutDio{
    .subBtn{
      font-size: 0.3rem;
      color: #333;
      padding: 0.2rem 0.3rem;
    }
    .el-dialog__body{ padding: 0 0.4rem;}
    .tips{
      font-size: 0.26rem;
      color: #999;
      text-align: left;
      margin-bottom: 0.2rem;
    }
    .contDio{
      display: flex;
      flex-wrap: wrap;
      border: 0.02rem solid #999;
      border-radius: 0.06rem;
      background-color: #f9f9f9;
      .item{
        width: 10%;
        height: 0.7rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #666;
        font-size: 0.3rem;
        &.error{
          color: #f30;
        }
      }
    }
  }
  .deliCont{
    height:10rem;
    display: flex;
    // align-items: center;
    justify-content: center;
    position: relative;
    text-align: center;
    .top238{
      padding-top: 2.38rem;
    }
    .manageBtn{
      position: absolute;
      width: 2.22rem;
      height: 2.22rem;
      font-size: 0.3rem;
      color: #151c36;
      background: url('../../../../static/FreshCabinet/images/btn_blue_circle_normal.png') no-repeat;
      background-size: cover;
      border-radius: 50%;
      overflow: hidden;
      top: 50%;
      margin-top: -1.11rem;
      right: 50%;
      margin-right: -6rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .item{
      font-size: 0.4rem;
      margin: 0.4rem 0;
      .tips{
        color: #151c36;
      }
      .Fbtn{
        background: #151c36;
        width: 7rem;
        height: 1.5rem;
        line-height: 1.5rem;
        font-size: 0.4rem;
        color: #fff;
        border-radius: 0.13rem;
      }
    }
  }
  .overTime{
		color: #666;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/FreshCabinet/deliveryType/deliveryType.vue